export default __webpack_public_path__ + "static/media/ch_1.52bf9eaf.mp3";